import clsx from 'clsx'
import { FC } from 'react'

import { RequestsTypeSelectOption } from './RequestsTypeSelect.types'

type Props = {
  className?: string
  value: RequestsTypeSelectOption
  onChange?: (value: RequestsTypeSelectOption) => void
  options: RequestsTypeSelectOption[]
}

const RequestsTypeSelector: FC<Props> = props => {
  const { value, onChange, options, className } = props

  const activeIndex = options.findIndex(option => option.key === value?.key)

  const handleFilterClick = (index: number) => {
    onChange?.(options[index])
  }

  return (
    <div
      className={clsx(
        'flex w-full justify-items-start gap-56 md:gap-40 sm:justify-around sm:gap-0',
        className
      )}
    >
      {options.map((option, index) => (
        <button
          key={option.key}
          className={clsx(
            'inline-flex max-w-max cursor-pointer gap-x-4 border-b-[3px] pb-8 font-bold transition-colors text-28 md:text-20',
            'sm:max-w-none sm:flex-1 sm:justify-center',
            activeIndex === index
              ? 'border-bronze-40 text-grey-100'
              : 'border-transparent text-grey-60'
          )}
          onClick={() => handleFilterClick(index)}
        >
          <span>{option.title}</span>
        </button>
      ))}
    </div>
  )
}

export default RequestsTypeSelector
